import { useQuery } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { getRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';

import type { RequestDataArray } from 'src/types/requestData';

const mapFieldTypeOptions = (
  option: UCM.FieldTypeOptionRawType,
): UCM.FieldTypeOptionType => ({
  value: option.code,
  label: option.input_type,
});

const getFieldTypeOptions = async () => {
  const { data } = await getRequest<
    RequestDataArray<UCM.FieldTypeOptionRawType>
  >(API.GET.dynamicFieldTypes);
  return data.data.map(({ attributes }) => mapFieldTypeOptions(attributes));
};

export const useGetFieldTypeOptions = (
  config: { enabled?: boolean } = { enabled: true },
) => {
  return useQuery({
    queryKey: [QUERY_KEYS.FIELD_TYPE_OPTIONS],
    queryFn: getFieldTypeOptions,
    staleTime: 1000 * 60 * 5,
    ...config,
  });
};
